var _module_exports = "<textarea id=\"{{ $ctrl.identifier }}\" class=\"form-control\" placeholder=\"{{ $ctrl.placeholder }}\"></textarea>\n";;
var path = 'app/portainer/components/code-editor/codeEditor.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;